import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

import Checkbox from '@/components/Checkbox';
import TermsLinks from '@/components/TermsLinks';
import useTerms from '@/hooks/use-terms';

type Props = {
  readonly className?: string;
};

const TermsAndPrivacyCheckbox = ({ className }: Props) => {
  const { termsAgreement, setTermsAgreement, termsOfUseUrl, privacyPolicyUrl, isTermsDisabled } =
    useTerms();
  const { t } = useTranslation();

  if (isTermsDisabled) {
    return null;
  }

  return (
    <div className={classNames('flex w-full', className)}>
      <Checkbox name="termsAgreement" checked={termsAgreement} onChange={setTermsAgreement}>
        <span className="text-xs/5 font-normal text-pretty text-muted">
          <Trans
            components={{
              link: (
                <TermsLinks
                  inline
                  termsOfUseUrl={termsOfUseUrl}
                  privacyPolicyUrl={privacyPolicyUrl}
                />
              ),
            }}
          >
            {t('description.agree_with_terms')}
          </Trans>
        </span>
      </Checkbox>
    </div>
  );
};

export default TermsAndPrivacyCheckbox;
